// extracted by mini-css-extract-plugin
export default {"wrapper":"MainTitle_wrapper__9kGLW","subtitle":"MainTitle_subtitle__ssl2C"};